import { render, staticRenderFns } from "./InternalGateway.vue?vue&type=template&id=8567adbc&scoped=true"
import script from "./InternalGateway.vue?vue&type=script&lang=js"
export * from "./InternalGateway.vue?vue&type=script&lang=js"
import style0 from "./InternalGateway.vue?vue&type=style&index=0&id=8567adbc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8567adbc",
  null
  
)

export default component.exports